import { DynamicFieldConfig } from '../models';

export interface InputFieldConfig extends DynamicFieldConfig {
  inputType?: string;
}
